import { INTL_DMY_CASUAL_SHORT_FORMAT, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { max, unique } from 'lib/array/arrayUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

export interface TourV2SnapshotDetails {
  countriesCount?: string
  placesCount?: string
  date: string | null
  formattedEndDate: string | null
  formattedStartDate: string | null
  daysCount?: string
  hasTheSameStartAndEndLocation?: boolean
}

function extractTourV2SnapshotDetails(snapshot: App.Tours.TourV2OfferSnapshot | undefined): TourV2SnapshotDetails {
  if (!snapshot?.itineraries?.length) {
    return {
      date: null,
      formattedStartDate: null,
      formattedEndDate: null,
      daysCount: undefined,
      countriesCount: undefined,
      placesCount: undefined,
      hasTheSameStartAndEndLocation: undefined,
    }
  }

  const lastDay = max(snapshot.itineraries, (item) => item.startDay)! // An itinerary will exist
  const daysCount = lastDay.startDay + lastDay.duration - 1
  const uniquePlaces = getTourV2PlacesVisited(snapshot.itineraries)
  const intl = getCurrentIntl()

  return {
    date: snapshot ? `${intlDateFormatter(snapshot.startDate, INTL_DMY_CASUAL_SHORT_FORMAT, intl.locale)} - ${intlDateFormatter(snapshot.endDate, INTL_DMY_CASUAL_SHORT_FORMAT, intl.locale)}` : null,
    formattedStartDate: snapshot ? intlDateFormatter(snapshot.startDate, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale) : null,
    formattedEndDate: snapshot ? intlDateFormatter(snapshot.endDate, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale) : null,
    hasTheSameStartAndEndLocation: snapshot.startLocation === snapshot.endLocation,
    daysCount: snapshot ? intl.formatMessage({
      id: 'D8zhpCrHZeSBk8luk_98',
      defaultMessage: '{count, plural, one {# day} other {# days}}',
      description: 'Tour snapshot duration in days on the tour offer detail page',
    }, { count: daysCount }) : undefined,
    countriesCount: snapshot.countriesVisited.length ? intl.formatMessage({
      id: 'Txib0u1Q5ryV0rfIFMBA',
      defaultMessage: '{count, plural, one {# country} other {# countries}}',
      description: 'Tour snapshot countries visited count on the tour offer detail page',
    }, { count: snapshot.countriesVisited.length }) : undefined,
    placesCount: uniquePlaces.length ? intl.formatMessage({
      id: 'SBl2IEgh821IkmO2IQX3',
      defaultMessage: '{count, plural, one {# place} other {# places}}',
      description: 'Tour snapshot places visited count on the tour offer detail page',
    }, { count: uniquePlaces.length }) : undefined,
  }
}

export function getTourV2PlacesVisited(itinerary: Array<App.Tours.TourV2OfferItineraryItem>): Array<string> {
  return unique(itinerary.flatMap(item => item.locationsVisited))
}

export default extractTourV2SnapshotDetails
